
import { defineComponent } from 'vue'
import LineChart from '@/components/charts/LineCart.vue'
export default defineComponent({
  components: {
    LineChart
  }
})
